const maybeRemoveTrailingSlash = (url: string) => {
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  }

  return url;
};

export const formatUrlToDomainAndPath = (url: string) => {
  try {
    const parsedURL = new URL(url);
    const domainAndPath = `${parsedURL.hostname}${parsedURL.pathname}`;

    if (domainAndPath.startsWith('www.')) {
      return maybeRemoveTrailingSlash(domainAndPath.slice(4));
    }

    return maybeRemoveTrailingSlash(domainAndPath);
  } catch {
    return url;
  }
};
